import { createEffect, createEvent, createStore, sample } from 'effector';
import { IRustmixBuyer, IRustmixBuyerOffer } from '../ts/rustmix-buyer.types';
import { BuyersService } from '@/modules/seller-account/services/buyers.service';
import { DiContainer } from '@/modules/di/di-container';
import { isArray } from 'lodash-es';
const buyersService = DiContainer.get(BuyersService);

// SELECTED BUYER PARAMS
const getRustmixBuyerPrices = createEvent();

export const $rustmixBuyerPrices = createStore<IRustmixBuyerOffer[]>([]).on(
  getRustmixBuyerPrices,
  (_, data) => {
    return data;
  },
);

export const fetchRustmixBuyerPricesFx = createEffect(async (buyer: IRustmixBuyer) => {
  try {
    let data = await buyersService.getUserBuyersOffers(buyer);
    return data;
  } catch (err) {
    return { error: err };
  }
});

sample({
  clock: fetchRustmixBuyerPricesFx.doneData,
  target: getRustmixBuyerPrices,
});

// NEW CALCULATOR LOGIC

// BUYERS LIST
export const getRustmixBuyers = createEvent();
export const setDataFromLs = createEvent();
export const switchAllRustmixBuyersState = createEvent<{ enabled: boolean }>();
export const switchSingleRustmixBuyerState = createEvent<{
  id: number;
  enabled: boolean;
}>();

const LOCAL_STORAGE_BUYERS_STATE_KEY = 'enabledCalculatorBuyers';
const localStorageBuyersState = String(
  localStorage.getItem(LOCAL_STORAGE_BUYERS_STATE_KEY),
);

const saveStateToLocalStorage = (state: any) =>
  localStorage.setItem(LOCAL_STORAGE_BUYERS_STATE_KEY, JSON.stringify(state));

export const $rustmixBuyers = createStore<{ data: IRustmixBuyer[] }>({ data: [] })
  .on(getRustmixBuyers, (_, data) => {
    return data;
  })
  .on(switchAllRustmixBuyersState, (state, payload) => {
    const reformed = {
      ...state,
      data: state.data?.map((item) => ({ ...item, local_enabled: payload.enabled })),
    };
    saveStateToLocalStorage(reformed);
    return reformed;
  })
  .on(switchSingleRustmixBuyerState, (state, payload) => {
    const reformed = {
      ...state,
      data: state.data.map((item) => {
        if (item.id === payload.id) {
          return { ...item, local_enabled: payload.enabled };
        }
        return item;
      }),
    };
    saveStateToLocalStorage(reformed);
    return reformed;
  });

// GET ALL OFFERS MATRIX
const initOffersMatrix = createEvent<any>();

export const $offersMatrix = createStore([]).on(initOffersMatrix, (state, payload) => {
  return payload;
});

export const fetchOffersMatrix = createEffect(
  async (args: { payload: IRustmixBuyer[] }) => {
    try {
      const pld = args.payload.map((item) => {
        if (item.local_enabled) {
          return {
            id: item.id,
            is_internal: item.type === 'internal' ? true : false,
          };
        }
      });
      let filteredPayload: { id: number; is_internal: boolean }[] | any = pld.filter(
        (element) => element !== undefined,
      );
      const data = await buyersService.getOffersMatrix({ payload: filteredPayload });
      return data;
    } catch (err: any) {
      const error = await err.json();
      return error;
    }
  },
);

sample({
  clock: fetchOffersMatrix.doneData,
  target: getRustmixBuyerPrices,
});

export const fetchRustmixBuyersFx = createEffect(async () => {
  try {
    const dataFromLs = JSON.parse(localStorage.getItem(LOCAL_STORAGE_BUYERS_STATE_KEY) || 'null');
    let data: any = await buyersService.getUserBuyers();
    const reformed = {
      ...data,
      data: data?.data?.map((item: any) => ({
        ...item,
        local_enabled:
        dataFromLs && isArray(dataFromLs.data)
          ? dataFromLs.data?.find((subItem: any) => item.id === subItem.id).local_enabled
          : true,
      })),
    };
    return reformed;
  } catch (err) {
    return { error: err };
  }
});

sample({
  clock: fetchRustmixBuyersFx.doneData,
  target: getRustmixBuyers,
});

// SELECTED_BUYER
export const setSelectedRustmixBuyer = createEvent<IRustmixBuyer>();

export const $selectedRustmixBuyer = createStore<IRustmixBuyer>({
  id: -1,
  company_name: '',
  type: 'external',
  distance: -1,
  enabled: 0,
  local_enabled: false,
}).on(setSelectedRustmixBuyer, (_, data) => {
  return data;
});

// CALCULATOR CARDS

const cardsStore = createStore({
  bagA: {
    weight: 0,
    gluten: 0,
    idk: 0,
    bug: 0,
    protein: 0,
    cp: 0,
    nature: 0,
    humidity: 0,
  },
  bagB: {
    weight: 0,
    gluten: 0,
    idk: 0,
    bug: 0,
    protein: 0,
    cp: 0,
    nature: 0,
    humidity: 0,
  },
  result: {
    weight: 0,
    gluten: 0,
    idk: 0,
    bug: 0,
    protein: 0,
    cp: 0,
    nature: 0,
    humidity: 0,
  },
});

const setBagAFieldVal = createEvent<{ field: string; val: string }>();
const setBagBFieldVal = createEvent<{ field: string; val: string }>();

cardsStore.on(setBagAFieldVal, (_, val) => {});
